<!-- <div class="content-heading">
  <i class="fa fa-times pull-right modalcloseicon" aria-hidden="true" (click)="cancelDialog()"></i>
  <h4>Template Legend</h4>
</div> -->
<div [className]="view == 'full' ? 'col-sm-12 p0' : 'col-sm-6 pl0'">
    <div [className]="view == 'full' ? 'p0' : 'panel panel-default p0'">
        <div class="content-data">
            <ul class="nav nav-pills p-lg">
                <li [ngClass]="{active: activeTab==='contact'}" class="template-legend-pill"><a class="pv-sm"
                        (click)="loadLegends('contact')">Contact</a></li>
                <li [ngClass]="{active: activeTab==='sender'}" class="template-legend-pill"><a class="pv-sm"
                        (click)="loadLegends('sender')">Account/Sender</a></li>
                <li [ngClass]="{active: activeTab==='roles'}" class="template-legend-pill"><a class="pv-sm"
                        (click)="loadLegends('roles')">Assigned
                        User</a></li>
                <li [ngClass]="{active: activeTab==='fields'}" class="template-legend-pill"><a class="pv-sm"
                        (click)="loadLegends('fields')">All
                        Fields</a></li>
                <li [ngClass]="{active: activeTab==='ai_variables'}" class="template-legend-pill"><a class="pv-sm"
                        (click)="loadLegends('ai_variables')">AI
                        Variables</a></li>
            </ul>

            <div *ngIf="!isLoaded" class="whirl standard spinnermargin"></div>
            <div class="legend-row" *ngIf="isLoaded">
                <!-- <ng-template ngFor let-legend [ngForOf]="selectedLegend" let-i="index">
                    <div *ngIf="activeTab == 'contact' || activeTab == 'sender'" class="col-sm-3 legend-row-data">
                        {{legend.name}}</div>
                    <div *ngIf="activeTab == 'contact' || activeTab == 'sender'" title="Insert Variable" style="cursor: pointer;"
                        (click)="insertTemplateLegend(true, null, legend.template)" class="col-sm-3 legend-row-data">
                        {{legend.template}}</div>
                    <div *ngIf="activeTab == 'roles' || activeTab == 'fields'" class="col-sm-3 legend-row-data">
                        {{legend.legend.name}}</div>
                    <div *ngIf="activeTab == 'roles' || activeTab == 'fields'" title="Insert Variable" style="cursor: pointer;"
                        (click)="insertTemplateLegend(true, null, legend.legend.template)"
                        class="col-sm-3 legend-row-data">
                        {{legend.legend.template}}</div>
                </ng-template> -->

                <div *ngIf="activeTab !== 'ai_variables'">
                    <div [className]="view == 'full' ? 'panel panel-default' : 'panel panel-default mt mb'">
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Template</th>
                                                <th>Description</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let legend of selectedLegend">
                                                <td>{{ (activeTab == 'contact' || activeTab == 'sender') ? legend.name :
                                                    legend.legend.name }}</td>
                                                <td>{{ (activeTab == 'contact' || activeTab == 'sender') ?
                                                    legend.template :
                                                    legend.legend.template }}</td>
                                                <td></td>
                                                <td class="text-center">
                                                    <div class="btn-group" dropdown>
                                                        <button type="button" class="btn btn-default btn-sm" dropdownToggle>
                                                            <b class=" caret"></b>
                                                        </button>
                                                        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right"
                                                            role="menu">
                                                            <li>
                                                                <a (click)="copyVariable(legend)">
                                                                    Copy</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="activeTab === 'ai_variables'">
                    <div [className]="view == 'full' ? 'panel panel-default' : 'panel panel-default mt mb'">
                        <div class="panel-heading">
                            <div>
                                <ng-template [ngxPermissionsOnly]="['templatelegends:can_get_templatelegends']">
                                    <div class="pull-right refresh-listing-icon ml" title="Refresh"
                                        (click)="getTemplateLegends()">
                                        <i class="fa fa-refresh fa-lg ml-sm" aria-hidden="true"></i>
                                    </div>
                                </ng-template>
                                <ng-template [ngxPermissionsOnly]="['templatelegends:can_post_templatelegends']">
                                    <div class="pull-right refresh-listing-icon ml" title="Add AI Variable"
                                        (click)="showAIVariableModal()">
                                        <i class="fa fa-plus fa-lg ml-sm" aria-hidden="true"></i>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Template</th>
                                                <th>Description</th>
                                                <!-- <th>Actions</th> -->
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngIf="selectedLegend?.length < 1; else variableList">
                                                <td colspan="3" class="text-center">No AI Variables found</td>
                                            </tr>

                                            <ng-container *ngFor="let legend of selectedLegend" #variableList>
                                                <!-- <tr style="cursor: pointer;" (click)="editVariable(legend.id);"> -->
                                                <tr style="cursor: pointer;" (click)="viewVariable(legend.name);">
                                                    <td>{{ legend.name }}</td>
                                                    <td>{{ legend.template }}</td>
                                                    <td>{{ truncateDescription(legend?.description, 45) }}</td>
                                                    <td class="text-center">
                                                        <div class="btn-group" dropdown>
                                                            <button type="button" class="btn btn-default btn-sm" dropdownToggle
                                                                (click)="$event.stopPropagation();">
                                                                <b class=" caret"></b>
                                                            </button>
                                                            <ul *dropdownMenu class="dropdown-menu dropdown-menu-right"
                                                                role="menu">
                                                                <!-- <li>
                                                                <a
                                                                    (click)="editVariable(legend.id); $event.stopPropagation()">Edit
                                                                    AI Variable</a>
                                                            </li> -->
                                                                <ng-template
                                                                    [ngxPermissionsOnly]="['templatelegends:can_delete_templatelegends']">
                                                                    <li>
                                                                        <a
                                                                            (click)="copyVariable(legend); $event.stopPropagation()">
                                                                            Copy</a>
                                                                    </li>
                                                                    <li *ngIf="!legend?.system_default">
                                                                        <a
                                                                            (click)="deleteVariable(legend.id); $event.stopPropagation()">Delete
                                                                            AI Variable</a>
                                                                    </li>
                                                                </ng-template>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </ng-container>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div [className]="view == 'full' ? 'col-sm-12 p0 mt' : 'col-sm-6 p0'">
    <div *ngIf="isAILegendSelected['selected']" class="panel panel-default p0">
        <div class="panel-heading">
            <h4>
                {{ isAILegendSelected.isAction == 'insert' ? 'Insert' : isAILegendSelected.isAction == 'edit' ? 'Edit' :
                isAILegendSelected.isAction == 'add' ? 'Add New' : 'View' }} AI Variable
                <button type="button" (click)="setAIVarDefaults()" class="close" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </h4>
        </div>
        <form #aiVariableForm="ngForm"
            (ngSubmit)="isAILegendSelected.isAction == 'insert' ? insertVariable(selectedEditLegend.name, true) : isAILegendSelected.isPreview ? generateAIPreview() : isAILegendSelected.isAction == 'edit' ? updateAIVar() : isAILegendSelected.isAction == 'add' ? addAIVar() : viewAIVar()">
            <div class="panel-body">
                <fieldset class="hidden">
                    <div class="form-group">
                        <label class="col-sm-2 control-label">ID</label>
                        <div class="col-sm-10">
                            <input type="hidden" class="form-control" [(ngModel)]="selectedEditLegend.id" name="id"
                                required [disabled]="true">
                        </div>
                    </div>
                </fieldset>
                <fieldset>
                    <div class="form-group">
                        <label class="col-sm-2 control-label">Name <label class="required"></label></label>
                        <div class="col-sm-10">
                            <input type="text" class="form-control" [(ngModel)]="selectedEditLegend.name" name="name"
                                required
                                [disabled]="(isAILegendSelected.isAction == 'insert' && isAILegendSelected.selected) || isAILegendSelected.isAction == 'view'">
                            <span class="text-danger"
                                *ngIf="!aiVariableForm?.controls['name']?.valid && aiVariableForm?.controls['name']?.dirty">This
                                field is
                                required</span>
                        </div>
                    </div>
                </fieldset>
                <fieldset>
                    <div class="form-group">
                        <label class="col-sm-2 control-label">Description <label class="required"></label></label>
                        <div class="col-sm-10">
                            <textarea style="resize: vertical;" class="form-control" rows="4" cols="50"
                                [(ngModel)]="selectedEditLegend.description" name="description" required
                                [disabled]="(isAILegendSelected.isAction == 'insert' && isAILegendSelected.selected) || isAILegendSelected.isAction == 'view'"></textarea>
                            <!-- <span class="text-danger" *ngIf="!aiVariableForm?.controls['description']?.valid">This field is
                            required</span> -->
                        </div>
                    </div>
                </fieldset>
                <fieldset>
                    <div class="form-group">
                        <label class="col-sm-2 control-label">Tone <label class="required"></label></label>
                        <div class="col-sm-10">
                            <select class="form-control" [(ngModel)]="selectedEditLegend.tone" name="tone" required
                                [disabled]="(isAILegendSelected.isAction == 'insert' && isAILegendSelected.selected) || isAILegendSelected.isAction == 'view'">
                                <option value="" disabled>Select Tone</option>
                                <option value="Direct">Direct</option>
                                <option value="Formal">Formal</option>
                                <option value="Causal">Causal</option>
                            </select>
                            <span class="text-danger"
                                *ngIf="!aiVariableForm?.controls['tone']?.valid && aiVariableForm?.controls['tone']?.dirty">This
                                field is
                                required</span>
                        </div>
                    </div>
                </fieldset>
                <fieldset>
                    <div class="form-group">
                        <label class="col-sm-2 control-label">Prompt <label class="required"></label></label>
                        <div class="col-sm-10 position-relative">
                            <textarea style="resize: vertical;" #editor class="form-control" rows="6" cols="50"
                                [(ngModel)]="selectedEditLegend.prompt" name="prompt" required
                                [disabled]="(isAILegendSelected.isAction == 'insert' && isAILegendSelected.selected) || isAILegendSelected.isAction == 'view'">
                        </textarea>

                            <!-- <i class="fa fa-refresh refresh-listing-icon" *ngIf="isAILegendSelected.isAction !== 'insert' && isPromptUpdated(selectedEditLegend.name)"
                            (click)="generateAIPreview()" title="Regenerate Preview"
                            style="position: absolute; top: 5px; right: 20px; cursor: pointer;"></i> -->
                            <span class="text-danger"
                                *ngIf="!aiVariableForm?.controls['prompt']?.valid && aiVariableForm?.controls['prompt']?.touched">This
                                field is
                                required.</span>
                            <span class="text-danger"
                                *ngIf="aiVariableForm?.controls['prompt']?.valid && selectedEditLegend.prompt?.length > 1000">
                                Prompt should be less than 1000 characters.</span>
                            <span class="text-danger"
                                *ngIf="aiVariableForm?.controls['prompt']?.valid && selectedEditLegend.prompt?.length < 10">
                                Prompt should be more than 10 characters.</span>
                        </div>
                    </div>
                </fieldset>
                <!-- <fieldset *ngIf="selectedEditLegend?.preview && !isGeneratingPreview">
                <div class="form-group">
                    <label class="col-sm-2 control-label">Preview</label>
                    <div class="col-sm-10 position-relative">
                        <textarea style="resize: vertical;" class="form-control" [readonly]="!isPreviewEditable"
                            rows="8" cols="50" [(ngModel)]="selectedEditLegend.preview" name="preview"
                            disabled></textarea>
                        <i class="fa fa-edit edit-icon" (click)="togglePreviewEdit()" title="Edit Preview"
                            style="position: absolute; top: 5px; right: 20px; cursor: pointer;"></i>
                    </div>
                </div>
            </fieldset> -->
            </div>
            <div class="panel-footer text-center">
                <div *ngIf="isSaveEditAIVar; else saveEditButtons" class="panel-footer text-center">
                    <div class="whirl standard"></div>
                </div>

                <ng-template #saveEditButtons>
                    <ng-container *ngIf="isAILegendSelected.isAction !== 'view'">
                        <button class="btn btn-default" type="button" (click)="setAIVarDefaults()">Cancel</button>
                        <!-- <button class="btn btn-info" type="submit" [disabled]="!aiVariableForm.form.valid" -->
                        <button class="btn btn-info" type="submit"
                            *ngIf="isAILegendSelected.isAction == 'insert'; else addEdit">
                            Insert
                        </button>
                        <ng-template #addEdit>
                            <button class="btn btn-info" type="submit" [disabled]="!aiVariableForm.form.valid"
                                *ngIf="!isAILegendSelected?.isPreview; else generatePreview">
                                {{ isAILegendSelected.isAction == 'edit' ? "Update" : "Add" }}
                            </button>
                            <ng-template #generatePreview>
                                <button class="btn btn-info" type="submit" [disabled]="!aiVariableForm.form.valid">
                                    <i class="fa fa-magic"></i>&nbsp;
                                    Generate AI Preview
                                </button>
                            </ng-template>
                        </ng-template>
                    </ng-container>
                </ng-template>
            </div>
        </form>
    </div>
</div>